import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorMessage } from '../../spotlight/models/purchase/error-message.model';

@Component({
  selector: 'app-purchase-flow',
  templateUrl: './purchase-flow.component.html',
  styleUrls: ['./purchase-flow.component.css']
})
export class PurchaseFlowComponent implements OnInit {

  @Input() eventId: number;
  @Input() premiere: any;
  @Input() purchaseStage: string;
  isLoading = true;
  isAlreadyInCart = false;
  errorMessage = new ErrorMessage();

  @Input() name;
  finalPaymentStage = false;
  cartStage = false;
  modalTitle: string;
  buyTksStage = false;
  transferURL: string;
  allAccessPassStage= false;

  changeError(errorMessage: ErrorMessage): void {
    this.errorMessage = errorMessage;
    console.log(errorMessage);
  }

  enableBuyTicket(): void {
    this.buyTksStage = true;
    this.finalPaymentStage = false;
    this.cartStage = false;
    this.isLoading = false;
    this.modalTitle = 'Buy Ticket';
  }

  enableCart(event: any): void {
    this.buyTksStage = false;
    this.finalPaymentStage = false;
    this.cartStage = true;
    this.isLoading = false;
    this.modalTitle = 'My Cart';
  }

  enableCheckOut(transferURL: string): void {
    this.transferURL = transferURL;
    this.buyTksStage = false;
    this.finalPaymentStage = true;
    this.cartStage = false;
    this.isLoading = false;
    this.modalTitle = 'Complete Payment';
  }

  enableAllAccessPass(): void {
    this.buyTksStage = true;
    this.finalPaymentStage = false;
    this.cartStage = false;
    this.isLoading = false;
    this.allAccessPassStage = true;
    this.modalTitle = 'Buy Ticket';
  }

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    switch (this.purchaseStage) {
      case 'Buy': {
        this.enableBuyTicket();
        break;
      }
      case 'all-access-pass': {
        this.enableAllAccessPass();
        break;
      }
      case 'Cart': {
        this.enableCart(null);
        break;
      }
      case 'Payment': {
        this.modalTitle = 'Complete Payment';
        break;
      }
   }
  }

  closeModal(): void {
    this.activeModal.close();
  }

}
